interface IDetailRowProps {
    label: string
    value: string
    isLast?: boolean
}

export const DetailRow = (props: IDetailRowProps) => {
    return (
        <div className={`flex flex-row justify-between items-center ${props.isLast ? '' : 'md:pb-[28px] pb-5 border-b-1 border-formSubSep'}`}>
            <div className={'md:text-xl text-lg text-primaryText font-sf-pro-light'}>{props.label}</div>
            <div className={'md:text-xl text-lg text-primaryText font-sf-pro-light text-right max-w-1/2'}>{props.value}</div>
        </div>
    )
}